var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "teas-cell",
        "mobile",
        "teas-cell-" + _vm.cellShape,
        _vm.border ? "dsf-teas-border-bottom" : "",
      ],
    },
    [
      _vm._t("front"),
      _vm.headerUrl || _vm.headerIcon || _vm.headerSvg
        ? _c(
            "div",
            { staticClass: "teas-cell-hd" },
            [
              _vm.headerUrl
                ? _c("van-image", {
                    class: [
                      "teas-cell-hd-header-img",
                      "teas-cell-hd-header-img-" + _vm.headerShape,
                    ],
                    attrs: {
                      src: _vm._f("imgFormat")(_vm.headerUrl),
                      "error-icon": _vm.errorimg,
                    },
                  })
                : _vm._e(),
              _vm.headerIcon
                ? _c("i", {
                    staticClass: "teas-cell-hd-header-icon",
                    class: ["iconfont", _vm.headerIcon],
                  })
                : _vm._e(),
              _vm.headerSvg
                ? _c(
                    "svg",
                    {
                      staticClass: "teas-cell-hd-svg-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("use", { attrs: { "xlink:href": _vm.headerSvg } })]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "teas-cell-bd" },
        [
          _c(
            "div",
            { class: ["teas-cell-bd-title"] },
            [
              _vm._t("titleLeft"),
              _c("div", { class: ["title", _vm.titleClass] }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._t("titleRight"),
            ],
            2
          ),
          _vm._t("default"),
        ],
        2
      ),
      _vm.hasFtSlot
        ? _c("div", { staticClass: "teas-cell-ft" }, [_vm._t("ft")], 2)
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }